import * as React from 'react';
import type { JsonLogicControlOptions } from '@web-config-app/core';

type AiAssistConfig = JsonLogicControlOptions['aiAssist'];

interface RuleCombinationProviderContextValueProps {
  combinationFieldPath: string;
  isArray: boolean;
  aiAssist?: AiAssistConfig;
}

export const RuleCombinationProviderContextContext =
  React.createContext<RuleCombinationProviderContextValueProps | null>(null);

export const RuleCombinationControlProvider = ({
  children,
  combinationFieldPath,
  isArray,
  aiAssist,
}: React.PropsWithChildren<RuleCombinationProviderContextValueProps>) => {
  const value = React.useMemo(
    () => ({
      combinationFieldPath,
      isArray,
      aiAssist,
    }),
    [aiAssist, combinationFieldPath, isArray],
  );

  return (
    <RuleCombinationProviderContextContext.Provider value={value}>
      {children}
    </RuleCombinationProviderContextContext.Provider>
  );
};

export const useRuleCombinationContext = () => {
  const ctx = React.useContext(RuleCombinationProviderContextContext);
  return ctx;
};
